import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CustomPropTypes } from '@beef/react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { YamsCoreController } from "../../controllers/YamsCoreController";
import { Map, YMaps, ZoomControl } from "../../react-yandex-maps";
import { YamsApi } from "../YamsApi";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Yams = function Yams(_ref) {
  var apikey = _ref.apikey,
    children = _ref.children,
    className = _ref.className,
    controller = _ref.controller,
    defaultState = _ref.defaultState,
    _ref$modules = _ref.modules,
    modules = _ref$modules === void 0 ? [] : _ref$modules,
    onClick = _ref.onClick,
    options = _ref.options,
    positionTop = _ref.positionTop,
    refWrapMap = _ref.refWrapMap;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component', className),
    ref: refWrapMap,
    "data-t-id": "components-Yams"
  }, /*#__PURE__*/React.createElement(YamsApi, {
    controller: controller
  }, function (_ref2) {
    var instanceRef = _ref2.instanceRef,
      isReady = _ref2.isReady,
      onLoad = _ref2.onLoad;
    return /*#__PURE__*/React.createElement(YMaps, {
      query: {
        apikey: apikey
      }
    }, /*#__PURE__*/React.createElement(Map, {
      className: cn('map'),
      defaultState: defaultState,
      instanceRef: instanceRef,
      modules: [].concat(_toConsumableArray(modules), _toConsumableArray(controller.modules)),
      onClick: onClick,
      onLoad: onLoad,
      options: _objectSpread({
        avoidFractionalZoom: true,
        dragCursor: 'arrow',
        maxZoom: 17,
        minZoom: 10,
        suppressMapOpenBlock: true,
        yandexMapDisablePoiInteractivity: true
      }, options),
      "data-t-id": "components-Yams"
    }, /*#__PURE__*/React.createElement(ZoomControl, {
      options: {
        float: 'none',
        position: {
          right: 22,
          top: positionTop
        },
        size: 'small'
      },
      "data-t-id": "components-Yams"
    }), isReady ? children : null));
  }));
};
Yams.propTypes = process.env.NODE_ENV !== "production" ? {
  apikey: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  controller: PropTypes.instanceOf(YamsCoreController),
  defaultState: PropTypes.shape({}),
  modules: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  options: PropTypes.shape({}),
  positionTop: PropTypes.number,
  refWrapMap: CustomPropTypes.ref
} : {};